import { render, staticRenderFns } from "./index.html?vue&type=template&id=13a86f81&scoped=true&"
import script from "./logout.js?vue&type=script&lang=js&"
export * from "./logout.js?vue&type=script&lang=js&"
import style0 from "./logout.scss?vue&type=style&index=0&id=13a86f81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a86f81",
  null
  
)

export default component.exports